/**
 * Who belongs in the customer portal rather than this console
 * (docs/PLAN-CUSTOMER-PORTAL-2026-09-30.md).
 *
 * The console's whole API is staff-only (`audience: 'staff'`), so a client who
 * signed in here got "staff role required" from every screen. Anyone whose
 * role in the current organisation is not a staff role is sent to the portal,
 * which shows them only the sites granted to them. Mirrors `isStaff` in
 * src/auth/membership.ts; test/portal_redirect.test.ts fails if they differ.
 */

export const STAFF_ROLES: readonly string[] = ['owner', 'admin', 'operator', 'viewer'];

export const PORTAL_PATH = '/portal/';

/** True when this role in the current organisation should use the portal. */
export function belongsInPortal(role: string | null | undefined): boolean {
  return typeof role === 'string' && !STAFF_ROLES.includes(role);
}
